export const useSearchByCollection = (collectionId, checkInDate, checkOutDate) =>
  useSearch(collectionId, checkInDate, checkOutDate, false);
